export default __webpack_public_path__ + "static/media/Mark-3-HUD-Pop-Up (2 Layers).412d998f.jpg";